export type Session = {
  isAuthenticated: boolean;
  redirectPath: string;
  accessToken: string;
  currentCompanyId?: string;
};

export const INITIAL_SESSION: Session = {
  redirectPath: '',
  isAuthenticated: false,
  accessToken: '',
};
